export { SelectDropDownComponent } from './components';
export { SelectDropDownModule } from './ngx-select-dropdown.module';
export { ArrayFilterPipe } from './pipes';
export { LimitToPipe } from './pipes';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts